import React from "react";

const Bash_Certificate = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Certificate</h2>
      <p>This placeholder shows where certificate/achievement details would appear. You can integrate with your site's certificate generator to award users on completion.</p>
    </div>
  );
};

export default Bash_Certificate;
